module.exports = __webpack_public_path__ + "img/1080_18.64665ac8.jpg";